import { useState } from "react";
import { Form, Button, Row, Col, Container, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { stateList } from "../../constants/states";
import { BtnClsNames, SubmitBtnStyle } from "../../config/btn_config";
import { EndUserAgreement } from "../../core/eua";
import { signUp } from "./fncs/auth_fncs";
import { useNavigate } from "react-router-dom";
export const SignUpForm = () => {
    const navigate = useNavigate();
    const [modalShow, setModalShow] = useState(false);
    const [formData, setFormData] = useState({
        agreement: false,
        first_name: '',
        last_name: '',
        state: '',
        city: '',
        phone_number: '',
        username: '',
        password: '',
        confirmPassword: '',
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        //extract what we want to payload
        const { agreement, confirmPassword, ...payload } = formData;
        if (validatPasswords()) {
            const result = await signUp(payload);
            if (result) {
                navigate('/')
            } else {
                toast.error("An error has occurred.")
            }
        }
    };

    const validatPasswords = () => {
        if (formData.password !== formData.confirmPassword) {
            toast.error("Passwords do not match.");
            return false;
        }
        return true;
    };

    return (
        <Container>
            <Row className='justify-content-center' style={{ paddingTop: '100px', paddingBottom: '15px' }}>
                <Form onSubmit={handleSubmit} className="p-4">
                    <Form.Group controlId="agreement" className="mb-3">
                        <Form.Check
                            type="checkbox"
                            label="I agree to the End User Agreement"
                            name="agreement"
                            checked={formData.agreement}
                            onChange={handleChange}
                            required
                        />
                        <Form.Text className="link-primary text-decoration-underline ms-4" role="button" onClick={() => setModalShow(true)}>View End User Agreement</Form.Text>
                    </Form.Group>

                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="firstName" className="mb-3">
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="first_name"
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="lastName" className="mb-3">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="last_name"
                                    value={formData.last_name}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="phone" className="mb-3">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="phone_number"
                                    value={formData.phone_number}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="state" className="mb-3">
                                <Form.Label>State</Form.Label>
                                <Form.Select
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select State</option>
                                    {stateList.map((s) => (
                                        <option key={s.value} value={s.value}>
                                            {s.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="city" className="mb-3">
                                <Form.Label>City</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="username" className="mb-3">
                                <Form.Label>Username</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="username"
                                    value={formData.username}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="password" className="mb-3">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="confirmPassword" className="mb-3">
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='justify-content-center text-center mt-3'>
                        <Col xs={12} sm={10} md={6} lg={4}>
                            <Button className={BtnClsNames} style={SubmitBtnStyle} type="submit">
                                Register
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Row>
            <Modal
                size="lg"
                centered
                scrollable
                show={modalShow}
                onHide={() => setModalShow(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        End User Agreement
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EndUserAgreement />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setModalShow(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
}